"use client";
import { useAuthError } from "@/context/AuthErrorContext";
import UnauthorizedPage from "@/app/unauthorized/page";

export function AuthErrorBoundary({ children }: { children: React.ReactNode }) {
    const { authError } = useAuthError();

    // Show unauthorized page if there's an auth error
    if (authError) {
        return <UnauthorizedPage />;
    }

    return children;
}
